<template>
    <div id="login">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-center" id="logo-login">
                                <img src="img/logo.png" width="200px">
                            </div>

                        </template>
                        <template>
                            <form role="form">
                                <base-input
                                        class="mb-3"
                                        type="number"
                                        placeholder="Introduzca su pin"
                                        v-model="loginData.pin"
                                        v-on:keyup.enter="login"
                                        autofocus
                                        addon-left-icon="ni ni-lock-circle-open">
                                </base-input>

                                <div class="text-center">
                                    <base-button type="primary" class="my-4" @click.prevent="login"
                                                 :disabled="disabledBotonLogin  == 1 ? true : false">
                                        {{textBotonLogin}}
                                    </base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'

    export default {
        data: function () {
            return {
                errorLogin: false,
                textBotonLogin: "Iniciar sesión",
                disabledBotonLogin: 0,
                loginData: {
                    pin: "",
                }
            }
        },
        methods: {
            login() {
                this.disabledBotonLogin = 1;
                this.textBotonLogin = "Comprobando...";

                this.checkInputs();
                if (!this.errorLogin) {
                    let vm = this;
                    axios.post(this.$store.getters.apiUrl + 'login-entrenador', {
                        pin: vm.loginData.pin,
                    }).then(response => {
                        if (response.data.response) {
                            vm.$router.push("/entrenadores/balones?jwt="+response.data.result["jwt"]);
                        } else {
                            swal({
                                title: 'Atención',
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            this.textBotonLogin = "Iniciar sesión";
                            this.disabledBotonLogin = 0;

                        }
                    }).catch(e => {
                        swal({
                            title: 'Atención',
                            text: e,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.textBotonLogin = "Iniciar sesión";
                        this.disabledBotonLogin = 0;

                    });
                } else {
                    this.textBotonLogin = "Iniciar sesión";
                    this.disabledBotonLogin = 0;
                }
            },
            checkInputs() {

                if (this.loginData.pin == "") {
                    this.errorLogin = true;
                    swal({
                        title: 'Atención',
                        text: "El pin no puede estar en blanco",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return;
                }

                this.errorLogin = false;
            },

        }
    };
</script>
<style scoped>
    #login {
        background: linear-gradient(87deg, #111 0%, #589dc3 120%) !important;
        min-height: 100vh;
    }

    .container {
        padding-top: 4em;
    }

    #logo-login {
        margin-bottom: 20px;
    }

    @media (max-width: 600px) {
        .container {
            padding-top: 2rem;
        }
    }
</style>
